export default __webpack_public_path__ + "static/twitter-web-9f4da2591d33bcc9952f6f37f4c2534c.png";